module.exports = __webpack_public_path__ + "img/notFound.64f2eccd.svg";